// Avatar.jsx
import "./Avatar.scss";
import { FaChevronDown } from "react-icons/fa6";
import { Button, Dropdown, Tooltip } from "antd";
import { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { HiOutlineHeart } from "react-icons/hi2";
import { UserContext } from "../../../context/userContext";
import CartDropdown from "../../../components/CartDropdown";

function Avatar({ scroll }) {
  const [rotate, setRotate] = useState(false);
  const { currentUser } = useContext(UserContext);

  const items = [
    {
      label: (
        <Link to={`/user/${currentUser?.username}`} className="items-drop">
          Hồ sơ của bạn
        </Link>
      ),
      key: "0",
    },
    {
      label: (
        <Link to="/edit-profile" className="items-drop">
          Chỉnh sửa hồ sơ
        </Link>
      ),
      key: "1",
      disabled: true,
    },
    {
      label: (
        <Link to="/logout" className="items-drop">
          Đăng xuất
        </Link>
      ),
      key: "2",
    },
  ];

  return (
    <div className="avatar">
      <Link to="/products/create">
        <Button className="login-btn sell">Bán ngay</Button>
      </Link>

      <Link to={`/user/${currentUser?.username}`}>
        <Tooltip title="Danh sách thích">
          <HiOutlineHeart className="login-icon" />
        </Tooltip>
      </Link>

      <CartDropdown />

      <div className="avt">
        <div className="avt-img">
          <img src={currentUser?.avatar} alt="avatar" />
        </div>

        <Dropdown
          menu={{ items }}
          trigger={["click"]}
          onOpenChange={(open) => setRotate(open)}
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
        >
          <div className={`avt-name ${scroll ? "scroll" : ""}`}>
            <span>{currentUser?.username}</span>
            <FaChevronDown className={`avt-icon ${rotate ? "rotate" : ""}`} />
          </div>
        </Dropdown>
      </div>
    </div>
  );
}

export default Avatar;
